module.exports = __webpack_public_path__ + "img/twitter.139f022c.svg";